import { Routes } from '@angular/router';
import { TermsComponent } from './terms/terms.component';
import { PolicyComponent } from './policy/policy.component';

export const StaticRoutes: Routes = [
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'policy',
    component: PolicyComponent
  }
];
